/* esm.sh - @radix-ui/react-use-is-hydrated@0.1.0 */
import{useSyncExternalStore as r}from"use-sync-external-store/shim";function n(){return r(e,()=>!0,()=>!1)}function e(){return()=>{}}export{n as useIsHydrated};
//# sourceMappingURL=react-use-is-hydrated.mjs.map